import { render, staticRenderFns } from "./PluginLoaderModal.vue?vue&type=template&id=0350b93d&"
import script from "./PluginLoaderModal.vue?vue&type=script&lang=js&"
export * from "./PluginLoaderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports